document.addEventListener('DOMContentLoaded', () => {
  const getSearchParam = (param, defaultValue) => new URLSearchParams(window.location.search).get(param) || defaultValue;

  const updateUrlParams = (letter, page) => {
    const url = new URL(window.location);
    url.searchParams.set('letter', letter);
    url.searchParams.set('page', page);
    window.location.href = url.toString();
  };

  const handleLetterClick = (event) => {
    event.preventDefault();
    const letter = event.currentTarget.getAttribute('data-letter');
    const page = getSearchParam('page', 1);
    updateUrlParams(letter, page);
  };

  const handlePageClick = (event) => {
    event.preventDefault();
    const page = event.currentTarget.getAttribute('data-page');
    const letter = getSearchParam('letter', 'A');
    updateUrlParams(letter, page);
  };

  document.querySelectorAll('[data-letter]').forEach(link => {
    link.addEventListener('click', handleLetterClick);
  });

  document.querySelectorAll('[data-page]').forEach(link => {
    link.addEventListener('click', handlePageClick);
  });
});